import {
  Rocket,
  MonitorPlay,
  LayoutGrid,
  Boxes,
  AppWindow,
  Settings,
  Braces,
  type LucideIcon,
} from "lucide-react";

// Category icons are referenced by name in the content registry; resolve them
// here so content stays plain data.
const MAP: Record<string, LucideIcon> = {
  Rocket,
  MonitorPlay,
  LayoutGrid,
  Boxes,
  AppWindow,
  Settings,
  Braces,
};

export function CategoryIcon({
  name,
  size = 22,
}: {
  name: string;
  size?: number;
}) {
  const Cmp = MAP[name] ?? LayoutGrid;
  return <Cmp size={size} aria-hidden="true" />;
}
